(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Standing-Leg"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const inputs = Array.from(document.querySelectorAll('.dimension-input'));
  inputs.forEach((input, index) => {
    input.addEventListener('keydown', (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const next = inputs[index + 1];
        if (next) next.focus();
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cantilever-legs-customiser"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const inputs = Array.from(document.querySelectorAll('.dimension-input'));
  inputs.forEach((input, index) => {
    input.addEventListener('keydown', (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const next = inputs[index + 1];
        if (next) next.focus();
      }
    });
  });

  const heavyDutyModal = document.getElementById('clc-heavy-duty-modal-{{ section.id }}');
  if (heavyDutyModal) {
    const closeModal = () => { heavyDutyModal.style.display = 'none'; };
    heavyDutyModal.querySelectorAll('[data-heavy-duty-modal-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });
    heavyDutyModal.style.display = 'flex';
    heavyDutyModal.querySelector('.clc-leadtime-modal__btn')?.focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panel-customiser-ips"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  const inputs = Array.from(document.querySelectorAll('.dimension-input'));

  inputs.forEach((input, index) => {
    input.addEventListener('keydown', (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const next = inputs[index + 1];
        if (next) next.focus();
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["panels-customiser-svg"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  const inputs = Array.from(document.querySelectorAll('.dimension-input'));

  inputs.forEach((input, index) => {
    input.addEventListener('keydown', (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        const next = inputs[index + 1];
        if (next) next.focus();
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();
})();
